/**
 * @module  modal
 *
 * @description 
 * <p>Clones or moves an element into a generated modal wrapper.</p>
 * <p>Puts moved element back where it found it when modal is closed.</p>
 * <p>NOTE: DO NOT CLONE ELEMENTS WITH IDs as it will result in multiple elements with the same ID in the DOM.</p>
 *
 * @fires site.ui.modal.modalClose
 * @fires site.ui.modal.modalOpen
 * 
 * @example
 * // listen to all images in a gallery and open a modal with a clone of that image on click
 * $('#gallery img').on('click', function(e){
 * 	modal.open($(e.target),'galImg',true);
 * });
 *
 * @namespace site.ui.modal
 */
;(/** @lends module:modal */ function(n,$,undefined){
	"use strict";
(function($){
	var trace = {push: function() {}},	// define trace if not loaded (set in init)
		
		modal = $('<div id="modalWrap"/>'),	// modal wrapper/mask
		container = $('<div class="modalContent"/>'),	// modal content container
		closeBtn = $('<a href="#" class="close" aria-label="Close"><i class="fa fa-times" aria-hidden="true" title="Close"></i><span class="sr-only">X</span></a>'),	// default close button. Can be replaced via modal.setCloseBtn()
		fadeSpd = 'slow',	// default fade-in/out speed. configurable via modal.setSpeed()
		obj = null,	// the DOM object to display in modalOpen
		objParent = null,	// the object's parent element for moved objects
		objBefore = null,	// the object's immediate previous sibling for moved objects
		isClone = false,	// flag for if the object should be cloned instead of moved
		isOpen = false,	// flag for is the modal open
		debug = false;	// flag for verbose trace output
			

	/**
	 * Initializer
	 * @private
	 */
	function init(){
		// Set module cache after all files have loaded (makes file load order unimportant)
		trace = n.utilities && n.utilities.trace ? n.utilities.trace : {push: function() {}};	// catch in case trace isn't loaded
		debug = n.debug || false;	// listen for global debug flag
	}

	/**
	 * Resets variables for re-use
	 * @private
	 */
	function reset() {
		obj = null;
		objParent = null;
		objBefore = null;
		isClone = false;
		isOpen = false;
		container.empty();
	}

	/**
	 * Builds the modal and sets the parent and sibling variables
	 * @arg  {object}  object  the jQuery object to open in a modal
	 * @arg  {string}  [cls]     an optional class to add to the modal wrapper
	 * @arg  {bool}  [clone = false]   should the object be cloned instead of moved
	 *
	 * @fires module:modal#modalOpen
	 */
	function open(object, cls, clone) {
		obj = object;
		objParent = obj.parent();
		objBefore = obj.prev();
		isClone = typeof clone !== 'undefined' ? clone : isClone;
		

		trace.push('Opening Modal');
		if(debug) {
			trace.push('buildModal object: ',obj);
			trace.push('buildModal class: '+cls);
			trace.push('buildModal isClone: '+isClone);
		}

		// if clone flag is true clone the original object
		obj = isClone ? obj.clone() : obj;

		// if custom class is defined add it to the wrapper
		if(cls) { modal.addClass(cls); }

		container.append(obj);	// append object to modal container
		modal.append(closeBtn).append(container);	// append container to modal
		
		/**
		 * modalOpen event
		 * @event site.ui.modal#modalOpen
		 */
		$(window).trigger('modalOpen');
		isOpen = true;

		modal.appendTo('body').hide().fadeIn(fadeSpd);

		closeBtn.on('click.modal', function(e){
			e.preventDefault();
			e.stopPropagation();

			close();
		});

	}

	/**
	 * Closes the modal and moves the object back where it got it if not a clone
	 * @fires modal#modalClose
	 */
	function close() {
		trace.push('Closing Modal');
		var hasSibling = objBefore && objBefore.length > 0,
			isChild	= objParent && objParent.length > 0;

		if(debug) {
			trace.push('buildModal object: ',obj);
			trace.push('buildModal hasSibling: '+hasSibling);
			trace.push('buildModal isChild: '+isChild);
			trace.push('buildModal isClone: '+isClone);
		}

		modal.fadeOut(fadeSpd, function(){

			if(!isClone) {
				if(hasSibling) {	// if object belongs after another element dump it there
					if(debug) trace.push('inserting obj after: ',objBefore);
					objBefore.after(obj);
				}
				else if(isChild) {	// Otherwise prepend it to its parent
					if(debug) trace.push('inserting obj into: ',objParent);
					objParent.prepend(obj);
				}
			}

			modal.removeClass();
			modal.remove();	// remove the modal from the DOM
		
			/**
			 * modalClose event
			 * @event site.ui.modal#modalClose
			 */
			$(window).trigger('modalClose');
			closeBtn.off('click.modal');	// unbind the button click so it doesn't duplicate

			reset();
		});
	}

	/**
	 * overwrite the default close button html
	 * @arg  {string}  btn  the Html to use for the close button
	 */
	function setCloseBtn(btn) {
		closeBtn = $(btn);
	}

	/**
	 * overwrite the default fadein/out speed
	 * @arg  {(number|string)}  spd  javascript speed value in miliseconds or 'slow','fast', etc.
	 */
	function setSpeed(spd) {
		fadeSpd = spd;
	}

	/**
	 * Turn debugging on/off for this module specifically
	 * @arg  {bool}  bool
	 */
	function setDebug(bool) {
		debug = bool;
	}

	// Public API
	n.ui = n.ui || {};
	n.ui.modal = {
		open : open,
		close : close,
		setCloseBtn : setCloseBtn,
		setSpeed : setSpeed,
		setDebug : setDebug
	};

	$(function(){
		init();
	});
	})(jQuery);
})(window.site = window.site || {}, jQuery);
